import { CircularProgress, Stack, Tooltip } from '@mui/material';
import { MediaButton, MediaButtonLabel, tooltipStyles } from './styles';
import { ArrowUpIcon } from '@/assets/icons/ArrowUpIcon';
import { ScreenshotIcon } from '@/assets/icons/ScreenshotIcon';
import { abyssColors } from '@/theme/colors';
import { useHavePermission, useRouter } from '@/hooks';
import { Permissions } from '@/types';
import { useMemo } from 'react';

type Props = {
  isUpdating: boolean;
  onUploadClick: () => void;
  onCaptureClick: () => void;
  children?: React.ReactNode;
};

export const MediaActionButtons = ({
  isUpdating,
  onUploadClick,
  onCaptureClick,
  children,
}: Props) => {
  const router = useRouter();
  const isAtInsightsPage = useMemo(() => router.pathname.includes('insights'), [router.pathname]);
  const userCanUploadMedia = useHavePermission(Permissions.CREATE_UPLOAD_MEDIA);

  return (
    <Stack direction="row" alignItems="start" gap={1.5} marginY={2}>
      {userCanUploadMedia && (
        <MediaButton disabled={isUpdating} onClick={onUploadClick} variant="outlined">
          {isUpdating ? <CircularProgress size={12} /> : <ArrowUpIcon />}
          <MediaButtonLabel>{isUpdating ? 'Uploading' : 'Upload'}</MediaButtonLabel>
        </MediaButton>
      )}
      {isAtInsightsPage ? (
        <Tooltip
          title="Only available in 3D viewer tab"
          disableHoverListener={false}
          arrow
          placement="top"
          PopperProps={{ sx: tooltipStyles }}
        >
          <span>
            <MediaButton variant="outlined" disabled>
              <ScreenshotIcon style={{ opacity: 0.5 }} />
              <MediaButtonLabel sx={{ color: abyssColors.neutral[400] }}>
                Capture View
              </MediaButtonLabel>
            </MediaButton>
          </span>
        </Tooltip>
      ) : (
        <MediaButton disabled={isUpdating} onClick={onCaptureClick} variant="outlined">
          {isUpdating ? <CircularProgress size={12} /> : <ScreenshotIcon />}
          <MediaButtonLabel>{isUpdating ? 'Capturing' : 'Capture View'}</MediaButtonLabel>
        </MediaButton>
      )}
      {children}
    </Stack>
  );
};
